import React, { FC, memo, useContext } from 'react';
import { Image, StyleSheet, View } from '@react-pdf/renderer';
import { Context as ClientsContext } from '../../../api/clients/context';
import { Client } from '../../../api/clients/types';

const localStyles = StyleSheet.create({
    wrapLogo: {
        position: 'absolute',
        top: 14,
        right: 0,
        left: 0
    },
    logo: {
        height: 70,
        margin: 'auto',
        width: 'auto'
    }
});

type Props = {
    pdfImageSource?: string;
};

const PdfLogo: FC<Props> = (props: Props) => {
    const clientsContext = useContext(ClientsContext);

    const { pdfImageSource = (clientsContext.selected as Client)?.companyLogoUrl } = props;

    // Skip rendering if no valid image source
    if (!pdfImageSource) {
        return null;
    }

    return (
        <View style={[localStyles.wrapLogo]} fixed>
            <Image style={localStyles.logo} source={pdfImageSource} />
        </View>
    );
};

export default memo(PdfLogo);
